import { z } from "zod";

export const GrvtConnectionStatus = {
  ONLINE: "online",
} as const;
export type GrvtConnectionStatus = (typeof GrvtConnectionStatus)[keyof typeof GrvtConnectionStatus];

export const AddGrvtAccountSchema = z.object({
  accountId: z.number().int().positive(),
  walletAddress: z.string().min(1),
  status: z.string(),
});
export type AddGrvtAccountDto = z.infer<typeof AddGrvtAccountSchema>;

export const GrvtBuilderPrepareResultSchema = z.object({
  prepareId: z.uuid(),
  eip712TypedData: z.object({
    types: z.record(z.string(), z.array(z.object({ name: z.string(), type: z.string() }))),
    primaryType: z.string(),
    domain: z.object({
      name: z.string(),
      version: z.string(),
      chainId: z.number(),
    }),
    message: z.record(z.string(), z.unknown()),
  }),
});
export type GrvtBuilderPrepareResultDto = z.infer<typeof GrvtBuilderPrepareResultSchema>;
